// extracted by mini-css-extract-plugin
export default {"cautionBox":"haa-z"};